import React, { useState, useEffect, useRef } from 'react';
import { Card, Typography, Tag, Button, Table, Space, Tooltip, Modal, message, Select, DatePicker, Switch, Descriptions, Tabs, Input, Progress, Checkbox, Popconfirm, Form, Row, Col, InputNumber, Divider, Steps, Alert, Upload, List } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { ArrowLeftOutlined, PlusOutlined, FileTextOutlined, EditOutlined, FilePdfOutlined, DollarOutlined, FileProtectOutlined, OrderedListOutlined, FolderOutlined, MessageOutlined, EyeOutlined, DownloadOutlined, DeleteOutlined, SearchOutlined, SyncOutlined, CalculatorOutlined, UploadOutlined, CalendarOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import ClientesCadastro from './Clientes';
import ContatoSelect from '../components/ContatoSelect';
import { usePermissao } from '../hooks/usePermissao';
import ModalComunicacao from '../components/ModalComunicacao';
import ModalVersoes from '../components/ModalVersoes';
import dayjs from 'dayjs';

const { Title, Text } = Typography;
// todos os botoes de ver documento com a mesma cara
const VER_PDF_ESTILO = { color: '#1890ff', borderColor: '#1890ff' };
const { Option } = Select;

const FORMAS_PAGAMENTO = ['À vista','Pix','Boleto','Cartão de crédito','10 dias','15 dias','30 dias','60 dias','90 dias','120 dias','30/60','30/60/90'];
const fmt = (v) => v != null ? 'R$ ' + parseFloat(v||0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '-';

const STATUS_PROPOSTA_CORES = { rascunho: 'default', proposta_enviada: 'blue', oc_recebida: 'cyan', agendado: 'purple', inspecionado: 'orange', laudo_emitido: 'green', nf_emitida: 'gold' };
const STATUS_PROPOSTA_LABELS = { rascunho: 'Rascunho', proposta_enviada: 'Enviada', oc_recebida: 'OC Recebida', agendado: 'Agendado', inspecionado: 'Inspecionado', laudo_emitido: 'Laudo Emitido', nf_emitida: 'NF Emitida' };
const STATUS_PGTO_CORES = { pendente: 'default', em_dia: 'success', vencido: 'error', pago: 'success' };
const STATUS_PGTO_LABELS = { pendente: 'Pendente', em_dia: 'Em dia', vencido: 'Vencido', pago: 'Pago' };
const STATUS_NF_CORES = { nao_emitida: 'default', emitida: 'blue', enviada: 'success' };
const STATUS_NF_LABELS = { nao_emitida: '-', emitida: 'Emitida', enviada: 'Enviada' };

function ClienteDetalhe() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [propostas, setPropostas] = useState([]);
  const [propostasProdutos, setPropostasProdutos] = useState([]);
  const [laudos, setLaudos] = useState([]);
  const [laudosFiltrados, setLaudosFiltrados] = useState([]);
  const [laudosExternos, setLaudosExternos] = useState([]);
  const [modalLaudosExternos, setModalLaudosExternos] = useState(false);
  const [arquivosUpload, setArquivosUpload] = useState([]);
  const [salvandoExternos, setSalvandoExternos] = useState(false);
  const [buscaLaudo, setBuscaLaudo] = useState('');
  const [filtroAno, setFiltroAno] = useState('');
  const [filtroTipoLaudo, setFiltroTipoLaudo] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [selecionados, setSelecionados] = useState([]);
  const [progresso, setProgresso] = useState(0);
  const [processando, setProcessando] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalFinanceiro, setModalFinanceiro] = useState(false);
  const [propostaSelecionada, setPropostaSelecionada] = useState(null);
  const [modalOS, setModalOS] = useState(false);
  const [formOS] = Form.useForm();
  const [usuarios, setUsuarios] = useState([]);
  const [osDetalhe, setOsDetalhe] = useState(null);
  const [editandoOS, setEditandoOS] = useState(false);
  const [formDetalhe] = Form.useForm();
  const [novaAnotacao, setNovaAnotacao] = useState('');
  const [modalLaudo, setModalLaudo] = useState(false);
  const [tipoLaudo, setTipoLaudo] = useState(null);
  const [subtipoLaudo, setSubtipoLaudo] = useState(null);
  const [subsubtipoLaudo, setSubsubtipoLaudo] = useState(null);
  const [modalNovaProposta, setModalNovaProposta] = useState(false);
  const { podeExcluir } = usePermissao();
  const [modalTipoProposta, setModalTipoProposta] = useState(false);
  const [stepProposta, setStepProposta] = useState(0);
  const [tipoDeslocamentoProp, setTipoDeslocamentoProp] = useState('perto');
  const [creaForaMGProp, setCreaForaMGProp] = useState(false);
  const [incluirARTProp, setIncluirARTProp] = useState(false);
  const [itensProposta, setItensProposta] = useState([]);
  const [calculoProposta, setCalculoProposta] = useState(null);
  const [cnpjSelecionadoProp, setCnpjSelecionadoProp] = useState(null);
  const [servicos, setServicos] = useState([]);
  const [cnpjsProp, setCnpjsProp] = useState([]);
  const [enderecosProp, setEnderecosProp] = useState([]);
  const [calcRotaProp, setCalcRotaProp] = useState(false);
  const [rotaInfoProp, setRotaInfoProp] = useState('');

  const calcularDeslocamentoProp = async () => {
    const sel = formProposta.getFieldValue('endereco_id');
    const e = enderecosProp.find(x => x.id === sel);
    if (!e) { message.warning('Selecione o endereço de atendimento primeiro'); return; }
    const destino = [e.logradouro, e.numero, e.bairro, e.cidade, e.estado, e.cep].filter(Boolean).join(', ');
    setCalcRotaProp(true);
    try {
      const r = await api.post('/propostas/calcular-deslocamento', { endereco: destino });
      const d = r.data;
      // sem pernoite a ida e volta se repete a cada dia de execucao (rotaVezes); com pernoite e uma viagem so
      const rotaVezes = formProposta.getFieldValue('tipo_deslocamento') === 'viagem' ? 1 : Math.max(parseInt(formProposta.getFieldValue('dias_execucao'), 10) || 1, 1);
      const r2 = (v) => Math.round((Number(v) || 0) * rotaVezes * 100) / 100;
      formProposta.setFieldsValue({ distancia_km: r2(d.km_total), horas_deslocamento: r2(d.horas_total), pedagio_valor: r2(d.pedagio_total), km_viagem: d.km_total });
      setRotaInfoProp('Ida ' + d.km_ida + ' km / volta ' + d.km_volta + ' km · ' + d.horas_total + ' h · pedágio R$ ' + d.pedagio_total.toFixed(2).replace('.', ',') + ' por dia' + (rotaVezes > 1 ? ' × ' + rotaVezes + ' dias = ' + r2(d.km_total) + ' km · ' + r2(d.horas_total) + ' h · pedágio R$ ' + r2(d.pedagio_total).toFixed(2).replace('.', ',') : '') + ' · destino: ' + d.endereco_destino);
      message.success('Deslocamento calculado — confira os valores');
    } catch (err) { message.error((err.response && err.response.data && err.response.data.erro) || 'Erro ao calcular rota'); }
    finally { setCalcRotaProp(false); }
  };
  const [contatosProp, setContatosProp] = useState([]);
  const [editandoCliente, setEditandoCliente] = useState(false);
  const [formProposta] = Form.useForm();
  const [formItensProp] = Form.useForm();
  const dadosRefProp = useRef({});
  const [formFinanceiro, setFormFinanceiro] = useState({});

  useEffect(() => {
    carregarDados();
    api.get('/usuarios').then(r => setUsuarios(r.data || [])).catch(() => {});
  }, [id]);

  const carregarDados = async () => {
    try {
      setLoading(true);
      const [rCliente, rPropostas, rPropostasProd, rLaudos, rCal, rLaudosExt, rOutros] = await Promise.all([
        api.get(`/clientes/${id}`),
        api.get(`/propostas/cliente/${id}`),
        api.get(`/propostas-produtos?cliente_id=${id}`),
        api.get(`/laudos/cliente/${id}`),
        api.get(`/laudos/calibracoes/cliente/${id}`),
        api.get(`/laudos-externos/cliente/${id}`),
        api.get(`/laudos/cliente/${id}/outros`).catch(() => ({ data: [] })),
      ]);
      setCliente(rCliente.data);
      const todasPropostas = [
        ...(rPropostas.data || []).map(p => ({...p, tipo_proposta: 'servico'})),
        ...(rPropostasProd.data || []).map(p => ({...p, tipo_proposta: 'produto'}))
      ].sort((a,b) => new Date(b.criado_em) - new Date(a.criado_em));
      setPropostas(todasPropostas);
      setPropostasProdutos(rPropostasProd.data || []);
      setLaudosExternos(rLaudosExt.data || []);
      const todosLaudos = [...(rLaudos.data || []), ...(rCal.data || []), ...(rOutros.data || []), ...(rLaudosExt.data || []).map(l => ({...l, origem: 'externo', tipo_laudo: l.tipo, proxima_inspecao_externa: l.data_proxima_atividade, codigo: 'EXT-' + l.id}))].sort((a,b) => new Date(b.criado_em)-new Date(a.criado_em));
      setLaudos(todosLaudos);
      setLaudosFiltrados(todosLaudos);
    } catch { message.error('Erro ao carregar dados do cliente'); }
    finally { setLoading(false); }
  };

  // Filtrar laudos
  const aplicarFiltros = (busca, ano, tipo) => {
    let filtrados = laudos;
    if (busca) filtrados = filtrados.filter(l => (l.codigo||'').toLowerCase().includes(busca) || (l.tag||'').toLowerCase().includes(busca));
    if (ano) filtrados = filtrados.filter(l => l.data_inspecao?.startsWith(ano));
    if (tipo) filtrados = filtrados.filter(l => (l.tipo_laudo||'').toLowerCase().includes(tipo));
    setLaudosFiltrados(filtrados);
  };

  // Download em massa em lotes de 5
  const chaveLaudo = (r) => (r.origem || '') + '_' + (r.origem_pai || '') + '_' + (r.tipo || '') + '_' + r.id;
  const laudoDaChave = (k) => laudos.find((l) => chaveLaudo(l) === k);
  const rotaPdfLaudo = (l) => {
    if (!l) return null;
    if (l.origem === 'inspecao') return '/laudos/' + l.id + '/pdf/visualizar';
    if (l.base) return l.base + '/' + l.id + '/pdf/visualizar';
    if (l.origem === 'calibracao_avulsa') return '/calibracoes/' + l.id + '/pdf/visualizar';
    if (l.origem === 'calibracao') return '/laudos/' + l.laudo_id + '/calibracoes/' + l.id + '/pdf/visualizar?origem=' + (l.origem_pai || 'laudo');
    return null;
  };

  const baixarEmMassa = async () => {
    setProcessando(true);
    setProgresso(0);
    const lote = 5;
    for (let i = 0; i < selecionados.length; i += lote) {
      const grupo = selecionados.slice(i, i + lote);
      await Promise.all(grupo.map(async (laudoId) => {
        try {
          const laudo = laudoDaChave(laudoId);
          const rota = rotaPdfLaudo(laudo);
          if (!rota) return;
          const r = await api.get(rota, { responseType: 'blob' });
          const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', (laudo?.codigo || laudoId) + '.pdf');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } catch {}
      }));
      setProgresso(Math.round(((i + lote) / selecionados.length) * 100));
      if (i + lote < selecionados.length) await new Promise(r => setTimeout(r, 1500));
    }
    setProcessando(false);
    setProgresso(0);
    message.success('Downloads concluídos!');
  };

  // Excluir em massa
  const excluirEmMassa = async () => {
    try {
      let pulados = 0;
      await Promise.all(selecionados.map(sid => {
        const laudo = laudoDaChave(sid);
        if (!laudo) return null;
        if (laudo.origem === 'externo') return api.delete('/laudos-externos/' + laudo.id);
        if (laudo.origem === 'inspecao') return api.delete('/laudos/' + laudo.id);
        if (laudo.origem === 'calibracao_avulsa') return api.delete('/calibracoes/' + laudo.id);
        if (laudo.base && laudo.origem !== 'autoclave') return api.delete(laudo.base + '/' + laudo.id);
        if (laudo.origem === 'calibracao' && laudo.laudo_id && laudo.tem_pdf) return api.delete('/laudos/' + laudo.laudo_id + '/calibracoes/' + laudo.id + '/pdf?origem=' + (laudo.origem_pai || 'laudo') + '&tipo=' + (laudo.tipo || ''));
        if (laudo.origem === 'livro') return api.delete('/laudos/' + laudo.id + '/livro-registro');
        if (laudo.origem === 'prontuario') return api.delete('/laudos/' + laudo.id + '/prontuario');
        pulados++; return null; // livro, prontuario e calibracao dentro de laudo: excluir pelo proprio laudo
      }));
      setSelecionados([]);
      await carregarDados();
      message.success('Laudos excluídos!' + (pulados ? ' (' + pulados + ' item(ns) de livro/prontuário/calibração não excluídos aqui: exclua pelo laudo)' : ''));
    } catch { message.error('Erro ao excluir'); }
  };

  const abrirNovaPropostaModal = async () => {
    try {
      const [rServicos, rCnpjs, rEnderecos, rContatos] = await Promise.all([
        api.get('/servicos'),
        api.get(`/clientes/${id}/cnpjs`),
        api.get(`/clientes/${id}/enderecos`),
        api.get(`/clientes/${id}/contatos`),
      ]);
      setServicos(rServicos.data || []);
      setCnpjsProp(rCnpjs.data || []);
      setEnderecosProp(rEnderecos.data || []);
      setContatosProp(rContatos.data || []);
      setItensProposta([]);
      setCalculoProposta(null);
      setStepProposta(0);
      formProposta.resetFields();
      formItensProp.resetFields();
      dadosRefProp.current = {};
      setModalNovaProposta(true);
    } catch { message.error('Erro ao carregar dados para proposta'); }
  };

  const adicionarItemProposta = (values) => {
    const s = servicos.find(s => s.id === values.servico_id);
    if (!s) return;
    setItensProposta([...itensProposta, { ...s, servico_id: s.id, quantidade: values.quantidade || 1 }]);
    formItensProp.resetFields();
  };

  const calcularProposta = async () => {
    if (itensProposta.length === 0) { message.warning('Adicione pelo menos um serviço'); return; }
    try {
      const valsForm = { ...formProposta.getFieldsValue(true), ...formItensProp.getFieldsValue(true) };
      dadosRefProp.current = { ...dadosRefProp.current, ...valsForm };
      const d = dadosRefProp.current;
      const payload = {
        cliente_id: parseInt(id),
        cnpj_faturamento_id: d.cnpj_faturamento_id || null,
        contato_id: d.contato_id || null,
        endereco_id: d.endereco_id || null,
        tipo_deslocamento: d.tipo_deslocamento || 'perto',
        dias_execucao: d.dias_execucao || 1,
        horas_deslocamento: d.horas_deslocamento || 0,
        distancia_km: d.distancia_km || 0,
        pedagio_valor: d.pedagio_valor || 0,
        horas_estacionamento: d.horas_estacionamento || 0,
        km_viagem: d.km_viagem || 0,
        dias_totais_viagem: d.dias_totais_viagem || 0,
        diarias_aluguel_carro: d.diarias_aluguel_carro || 0,
        km_deslocamento_local: d.km_deslocamento_local || 0,
        crea_fora_mg: creaForaMGProp,
        incluir_art: incluirARTProp,
        desconto: d.desconto || 0,
        desconto_observacao: d.desconto_observacao || null,
        forma_pagamento: d.forma_pagamento || null,
        validade_dias: d.validade_dias || 15,
        observacoes: d.observacoes || null,
        itens: itensProposta,
      };
      const r = await api.post('/propostas/calcular', payload);
      setCalculoProposta(r.data);
      // calculo pronto, resultado aparece na mesma etapa
    } catch(e) { message.error('Erro ao calcular proposta'); }
  };

  const salvarNovaProposta = async () => {
    try {
      const d = dadosRefProp.current;
      const payload = {
        cliente_id: parseInt(id),
        cnpj_faturamento_id: d.cnpj_faturamento_id || null,
        contato_id: d.contato_id || null,
        endereco_id: d.endereco_id || null,
        titulo: d.titulo || 'Proposta NR-13',
        tipo_deslocamento: d.tipo_deslocamento || 'perto',
        dias_execucao: d.dias_execucao || 1,
        horas_deslocamento: d.horas_deslocamento || 0,
        distancia_km: d.distancia_km || 0,
        pedagio_valor: d.pedagio_valor || 0,
        horas_estacionamento: d.horas_estacionamento || 0,
        km_viagem: d.km_viagem || 0,
        dias_totais_viagem: d.dias_totais_viagem || 0,
        diarias_aluguel_carro: d.diarias_aluguel_carro || 0,
        km_deslocamento_local: d.km_deslocamento_local || 0,
        crea_fora_mg: creaForaMGProp,
        incluir_art: incluirARTProp,
        desconto: d.desconto || 0,
        desconto_observacao: d.desconto_observacao || null,
        forma_pagamento: d.forma_pagamento || null,
        validade_dias: d.validade_dias || 15,
        observacoes: d.observacoes || null,
        itens: itensProposta,
      };
      const r = await api.post('/propostas', payload);
      message.success('Proposta criada com sucesso!');
      setModalNovaProposta(false);
      navigate(`/propostas/${r.data.id}`);
    } catch(e) { message.error('Erro ao salvar proposta'); }
  };

  const abrirModalFinanceiro = (proposta) => {
    setPropostaSelecionada(proposta);
    setFormFinanceiro({
      vencimento_boleto: proposta.vencimento_boleto ? dayjs(proposta.vencimento_boleto) : null,
      status_pagamento: proposta.status_pagamento || 'pendente',
      status_nf: proposta.status_nf || 'nao_emitida',
      inadimplente: proposta.inadimplente || false,
    });
    setModalFinanceiro(true);
  };

  const salvarFinanceiro = async () => {
    try {
      await api.put(`/propostas/${propostaSelecionada.id}/financeiro`, {
        ...formFinanceiro,
        vencimento_boleto: formFinanceiro.vencimento_boleto ? formFinanceiro.vencimento_boleto.format('YYYY-MM-DD') : null,
      });
      message.success('Dados financeiros atualizados!');
      setModalFinanceiro(false);
      carregarDados();
    } catch { message.error('Erro ao salvar dados financeiros'); }
  };

  const gerarPDF = async (proposta) => {
    try {
      const response = await api.get(`/propostas/${proposta.id}/pdf`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Proposta-${proposta.numero}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      message.success('PDF gerado!');
    } catch { message.error('Erro ao gerar PDF'); }
  };

  const fmt = (v) => `R$ ${parseFloat(v || 0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;

  const [modalComunicacao, setModalComunicacao] = useState(false);
  const [modalWA, setModalWA] = useState(false);
  const [propostaWA, setPropostaWA] = useState(null);
  const [numeroWA, setNumeroWA] = useState('');
  const [enviandoWA, setEnviandoWA] = useState(false);
  const [msgWA, setMsgWA] = useState('');
  const [anexosWA, setAnexosWA] = useState([]);
  const [dadosWA, setDadosWA] = useState(null);
  const [modalVersoes, setModalVersoes] = useState(false);
  const [propostaVersoes, setPropostaVersoes] = useState(null);
  const [propostaComunicacao, setPropostaComunicacao] = useState(null);

  const STATUS_COR = { aberta: 'blue', em_andamento: 'orange', pausada: 'gold', concluida: 'green', cancelada: 'red' };
  const STATUS_LABEL = { aberta: 'Aberta', em_andamento: 'Em andamento', pausada: 'Pausada', concluida: 'Concluída', cancelada: 'Cancelada' };

  const atualizarStatusOS = async (status) => {
    await api.put('/os/' + osDetalhe.id, { ...osDetalhe, status });
    setOsDetalhe({ ...osDetalhe, status });
    message.success('Status atualizado!');
  };

  const salvarAnotacao = async () => {
    if (!novaAnotacao.trim()) return;
    await api.post('/os/' + osDetalhe.id + '/historico', { texto: novaAnotacao });
    setNovaAnotacao('');
    const r = await api.get('/os/' + osDetalhe.id);
    setOsDetalhe(r.data);
  };

  const exportarICS = async (os) => {
    try {
      const r = await api.get('/os/' + os.id + '/ics', { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a'); a.href = url; a.download = 'os-' + os.id + '.ics'; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { console.error('Erro ao exportar ICS:', e.message); }
  };

  const abrirModalOS = async (proposta) => {
    setPropostaSelecionada(proposta);
    formOS.resetFields();
    // Pré-preencher status
    const fields = { status: 'aberta' };
    // Pré-preencher endereço
    if (proposta.end_logradouro) {
      fields.endereco_atendimento = proposta.end_logradouro + (proposta.end_numero ? ', ' + proposta.end_numero : '') + (proposta.end_bairro ? ' - ' + proposta.end_bairro : '') + (proposta.end_cidade ? ', ' + proposta.end_cidade : '') + (proposta.end_estado ? '/' + proposta.end_estado : '');
    }
    // Pré-preencher observações com itens da proposta
    if (proposta.tipo_proposta !== 'produto' && proposta.id) {
      try {
        const r = await api.get('/propostas/' + proposta.id);
        const itens = r.data?.itens || [];
        if (itens.length > 0) {
          fields.observacoes = itens.map(i => (i.quantidade || 1) + 'x ' + (i.descricao_personalizada || i.servico_nome || '')).join('\n');
        }
      } catch(e) { console.error('Erro ao buscar itens:', e.message); }
    } else if (proposta.tipo_proposta === 'produto') {
      fields.observacoes = 'Entrega/Instalação - Proposta ' + proposta.numero;
    }
    formOS.setFieldsValue(fields);
    setModalOS(true);
  };

  const gerarOS = async (proposta) => {
    try {
      const isProduto = proposta.tipo_proposta === 'produto';
      const r = await api.post('/os', {
        proposta_id: isProduto ? null : proposta.id,
        cliente_id: proposta.cliente_id,
        observacoes: 'OS gerada da proposta ' + proposta.numero,
      });
      message.success('OS ' + r.data.numero + ' criada!');
      window.location.href = '/agendamentos?os=' + r.data.id;
    } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
  };

  const acoesColuna = (proposta) => (
    <Space size={2}>
      <Tooltip title="Ver proposta"><Button icon={<EyeOutlined />} size="small" style={{color:'#1a3c5e',borderColor:'#1a3c5e'}} onClick={() => navigate(proposta.tipo_proposta === 'produto' ? `/propostas-produtos/${proposta.id}` : `/propostas/${proposta.id}`)} /></Tooltip>
      {podeExcluir && <Popconfirm title="Excluir esta proposta?" onConfirm={async () => {
        try {
          if (proposta.tipo_proposta === 'produto') await api.delete('/propostas-produtos/' + proposta.id);
          else await api.delete('/propostas/' + proposta.id);
          carregarDados();
          message.success('Proposta excluída!');
        } catch { message.error('Erro ao excluir'); }
      }}><Button icon={<DeleteOutlined />} size="small" danger /></Popconfirm>}
      <Tooltip title="Editar proposta"><Button icon={<EditOutlined />} size="small" style={{color:'#fa8c16',borderColor:'#fa8c16'}} onClick={() => navigate(proposta.tipo_proposta === 'produto' ? `/propostas-produtos/${proposta.id}` : `/propostas/${proposta.id}/editar`)} /></Tooltip>
      <Tooltip title="Gerar PDF"><Button icon={<FilePdfOutlined />} size="small" style={{color:'#cf1322',borderColor:'#cf1322'}} onClick={() => gerarPDF(proposta)} /></Tooltip>

      {proposta.tipo_proposta !== 'produto' && <Tooltip title="Gerar OS"><Button icon={<OrderedListOutlined />} size="small" style={{color:'#722ed1',borderColor:'#722ed1'}} onClick={() => gerarOS(proposta)} /></Tooltip>}
      <Tooltip title="Versões"><Button icon={<FileTextOutlined />} size="small" style={{color:'#531dab',borderColor:'#531dab'}} onClick={() => { setPropostaVersoes(proposta); setModalVersoes(true); }} /></Tooltip>
      <Tooltip title="Comunicação"><Button icon={<MessageOutlined />} size="small" style={{color:'#08979c',borderColor:'#08979c'}} onClick={() => { setPropostaComunicacao(proposta.id); setModalComunicacao(true); }} /></Tooltip>
      <Tooltip title="Enviar por WhatsApp"><Button icon={<WhatsAppOutlined />} size="small" style={{color:'#25d366',borderColor:'#25d366'}} onClick={async () => { 
  setPropostaWA(proposta); 
  setModalWA(true); 
  setNumeroWA('');
  setMsgWA(`Olá! Segue a proposta ${proposta.numero} no valor de R$ ${parseFloat(proposta.valor_total||0).toFixed(2).replace('.',',')}.

Acesse o portal: https://portal.celum.com.br

Qualquer dúvida estou à disposição!`);
  setAnexosWA(['proposta_pdf']);
  // Buscar dados da proposta (boleto, nfse)
  try {
    const r = await api.get(`/comunicacao/proposta/${proposta.id}`);
    setDadosWA(r.data);
  } catch(e) {}
  try {
    const r = await api.get(`/clientes/${id}/contatos`);
    setContatosProp(r.data || []);
  } catch(e) {}
}} /></Tooltip>
    </Space>
  );

  const colunas = [
    { title: 'Ações', key: 'acoes', width: 130, render: (_, r) => acoesColuna(r) },
    { title: 'Nº Proposta', dataIndex: 'numero', width: 120, render: (v) => <Text strong style={{ color: '#1a3c5e' }}>{v}</Text> },
    { title: 'Título', width: 180, ellipsis: true, render: (_, r) => r.titulo_contrato || r.titulo || '-' },
    { title: 'Status', width: 110, render: (_, r) => { const v = r.status; if (r.tipo_proposta === 'produto') { const cores = {rascunho:'default',enviada:'blue',aprovada:'green',recusada:'red',faturada:'gold',nf_enviada:'cyan'}; const labels = {rascunho:'Rascunho',enviada:'Enviada',aprovada:'Aprovada',recusada:'Recusada',faturada:'Faturada',nf_enviada:'NF Enviada'}; return <Tag color={cores[v]}>{labels[v]||v}</Tag>; } return <Tag color={STATUS_PROPOSTA_CORES[v]}>{STATUS_PROPOSTA_LABELS[v]}</Tag>; } },
    { title: 'Valor Total', width: 110, render: (_, r) => { const v = r.valor_total; return <Text strong>{fmt(v)}</Text>; } },

    { title: 'Pagamento', dataIndex: 'status_pagamento', width: 100, render: (v) => <Tag color={STATUS_PGTO_CORES[v || 'pendente']}>{STATUS_PGTO_LABELS[v || 'pendente']}</Tag> },

    { title: 'Inadim.', dataIndex: 'inadimplente', width: 80, render: (v) => v ? <Tag color="red">SIM</Tag> : <Tag color="green">NÃO</Tag> },
  ];

  if (loading || !cliente) return <div style={{ padding: 24 }}>Carregando...</div>;

  return (
    <>
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/clientes')}>Voltar</Button>
          <Title level={4} style={{ margin: 0 }}>{cliente.codigo} — {cliente.razao_social || cliente.nome}</Title>
          <Tag color={cliente.tipo === 'PJ' ? 'blue' : 'green'}>{cliente.tipo}</Tag>
        </div>
        <Space>
          <Button icon={<EditOutlined />} onClick={() => setEditandoCliente(true)}>Editar cliente</Button>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalTipoProposta(true)}>Nova Proposta</Button>
        </Space>
      </div>
      {editandoCliente && <ClientesCadastro embutido editarId={cliente.id}
        onFechar={() => setEditandoCliente(false)}
        onSalvo={() => { setEditandoCliente(false); carregarDados(); }} />}

      <Card size="small" style={{ marginBottom: 16 }}>
        <Descriptions column={3} size="small">
          <Descriptions.Item label="CNPJ/CPF">{cliente.cnpj || cliente.cpf || '-'}</Descriptions.Item>
          <Descriptions.Item label="Cidade">{cliente.cidade_fiscal || '-'}</Descriptions.Item>
          <Descriptions.Item label="Forma Pgto">{cliente.forma_pagamento || '-'}</Descriptions.Item>
        </Descriptions>
      </Card>

      <Tabs defaultActiveKey="propostas">
        <Tabs.TabPane tab={`Propostas (${propostas.length})`} key="propostas">
          <Card size="small">
            <Table columns={colunas} dataSource={propostas} rowKey="id" size="small" scroll={{ x: 1100 }} locale={{ emptyText: 'Nenhuma proposta encontrada.' }} rowClassName={(r) => r.inadimplente ? 'row-inadimplente' : ''} />
          </Card>
        </Tabs.TabPane>
        <Tabs.TabPane tab={`Laudos (${laudos.length})`} key="laudos">
          <Card size="small" extra={
            <Space>
            <Button type="primary" icon={<SyncOutlined />} size="small" onClick={async () => {
              try {
                const r = await api.post('/portal/sincronizar/' + id);
                message.success(r.data.sincronizados + ' laudo(s) sincronizados para o portal!');
              } catch(e) { message.error('Erro ao sincronizar: ' + (e.response?.data?.erro || e.message)); }
            }}>Sincronizar Portal</Button>
            <Button icon={<UploadOutlined />} size="small" onClick={() => setModalLaudosExternos(true)} style={{ marginLeft: 8 }}>Importar Laudos Externos</Button>
          </Space>}
          >
            {/* Filtros */}
            <Space wrap style={{ marginBottom: 12 }}>
              <Input.Search placeholder="Buscar por código ou TAG..." allowClear style={{ width: 220 }}
                onChange={e => {
                  const b = e.target.value.toLowerCase();
                  setBuscaLaudo(b);
                  aplicarFiltros(b, filtroAno, filtroTipoLaudo);
                }} />
              <Select allowClear placeholder="Filtrar por ano" style={{ width: 120 }} onChange={v => { setFiltroAno(v||''); aplicarFiltros(buscaLaudo, v||'', filtroTipoLaudo); }}>
                {[...new Set(laudos.map(l => l.data_inspecao?.substring(0,4)).filter(Boolean))].sort().reverse().map(a => <Select.Option key={a} value={a}>{a}</Select.Option>)}
              </Select>
              <Select allowClear placeholder="Tipo de laudo" style={{ width: 180 }} onChange={v => { setFiltroTipoLaudo(v||''); aplicarFiltros(buscaLaudo, filtroAno, v||''); }}>
                <Select.Option value="inspecao">Inspeção NR-13</Select.Option>
                <Select.Option value="calibracao">Calibração</Select.Option>
                <Select.Option value="livro">Livro de Registro</Select.Option>
                <Select.Option value="prontuario">Prontuário</Select.Option>
              </Select>
              <Select value={pageSize} onChange={v => setPageSize(v)} style={{ width: 80 }}>
                <Select.Option value={10}>10</Select.Option>
                <Select.Option value={20}>20</Select.Option>
                <Select.Option value={50}>50</Select.Option>
              </Select>
            </Space>
            {/* Acoes em massa */}
            {selecionados.length > 0 && (
              <Space style={{ marginBottom: 12 }}>
                <Tag color="blue">{selecionados.length} selecionado(s)</Tag>
                <Button size="small" icon={<DownloadOutlined />} loading={processando} onClick={() => baixarEmMassa()}>Baixar PDFs</Button>
                <Popconfirm title={`Excluir ${selecionados.length} laudos?`} onConfirm={() => excluirEmMassa()}>
                  <Button size="small" danger icon={<DeleteOutlined />}>Excluir</Button>
                </Popconfirm>
                <Button size="small" onClick={() => setSelecionados([])}>Limpar seleção</Button>
              </Space>
            )}
            {processando && <Progress percent={progresso} style={{ marginBottom: 12 }} />}
            <Table
              rowSelection={{ selectedRowKeys: selecionados, onChange: setSelecionados }}
              dataSource={laudosFiltrados}
              rowKey={chaveLaudo}
              size="small"
              pagination={{ pageSize, showSizeChanger: false }}
              scroll={{ x: 800 }}
              columns={[
                { title: 'Ações', width: 100, render: (_, r) => (
                  <Space size={4}>
                    {r.origem !== 'externo' && <Tooltip title="Editar laudo"><Button size="small" icon={<EditOutlined />} type="primary" onClick={() => navigate(r.base ? r.base + '/' + r.id : r.origem === 'calibracao_avulsa' ? '/calibracoes/'+r.id : (r.origem === 'calibracao' ? (r.origem_pai === 'externa' ? '/inspecoes-externas/' + r.laudo_id : r.origem_pai === 'camara' ? '/inspecoes-camara/' + r.laudo_id : '/laudos/'+r.laudo_id) : '/laudos/'+r.id))} /></Tooltip>}
                    {r.base && <Tooltip title="Ver PDF"><Button size="small" icon={<EyeOutlined />} style={VER_PDF_ESTILO} disabled={!r.tem_pdf} onClick={async () => {
                      try {
                        const res = await api.get(r.base + '/' + r.id + '/pdf/visualizar', { responseType: 'blob' });
                        window.open(window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' })), '_blank');
                      } catch { message.warning('PDF ainda não gerado. Gere pela página do laudo.'); }
                    }} /></Tooltip>}
                    {r.origem === 'inspecao' && <Tooltip title="Ver PDF"><Button size="small" icon={<EyeOutlined />} style={VER_PDF_ESTILO} onClick={async () => {
                      try {
                        const res = await api.get('/laudos/'+r.id+'/pdf/visualizar', { responseType: 'blob' });
                        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                        window.open(url, '_blank');
                      } catch { message.error('PDF não disponível'); }
                    }} /></Tooltip>}
                    {r.origem === 'livro' && <Tooltip title="Ver Livro"><Button size="small" icon={<EyeOutlined />} style={VER_PDF_ESTILO} onClick={async () => {
                      try {
                        const res = await api.get('/laudos/'+r.id+'/livro-registro/visualizar', { responseType: 'blob' });
                        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                        window.open(url, '_blank');
                      } catch { message.error('Erro ao abrir livro'); }
                    }} /></Tooltip>}
                    {r.origem === 'prontuario' && <Tooltip title="Ver Prontuário"><Button size="small" icon={<EyeOutlined />} style={VER_PDF_ESTILO} onClick={async () => {
                      try {
                        const res = await api.get('/laudos/'+r.id+'/prontuario/visualizar', { responseType: 'blob' });
                        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                        window.open(url, '_blank');
                      } catch { message.error('Erro ao abrir prontuário'); }
                    }} /></Tooltip>}
                    {r.origem === 'calibracao' && r.origem_pai && <Tooltip title="Ver PDF Calibração"><Button size="small" icon={<EyeOutlined />} style={VER_PDF_ESTILO} disabled={!r.tem_pdf} onClick={async () => {
                      try {
                        const res = await api.get('/laudos/' + r.laudo_id + '/calibracoes/' + r.id + '/pdf/visualizar?origem=' + r.origem_pai, { responseType: 'blob' });
                        window.open(window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' })), '_blank');
                      } catch { message.warning('PDF da calibração ainda não gerado.'); }
                    }} /></Tooltip>}
                    {r.origem === 'calibracao' && !r.origem_pai && <Tooltip title="Ver PDF Calibração"><Button size="small" icon={<EyeOutlined />} style={VER_PDF_ESTILO} onClick={async () => {
                      try {
                        const res = await api.get('/laudos/' + r.laudo_id + '/calibracoes/' + r.id + '/pdf/visualizar?origem=' + (r.origem || 'laudo'), { responseType: 'blob' });
                        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                        window.open(url, '_blank');
                      } catch { message.error('Erro ao abrir PDF de calibração'); }
                    }} /></Tooltip>}
                    {r.origem === 'calibracao_avulsa' && <Tooltip title="Ver PDF da Calibração"><Button size="small" icon={<EyeOutlined />} style={VER_PDF_ESTILO} onClick={async () => {
                      message.loading({ content: 'Abrindo PDF...', key: 'calpdf', duration: 0 });
                      try {
                        const res = await api.get('/calibracoes/' + r.id + '/pdf/visualizar', { responseType: 'blob' });
                        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                        window.open(url, '_blank');
                        message.destroy('calpdf');
                      } catch { message.destroy('calpdf'); message.error('Erro ao abrir PDF de calibração'); }
                    }} /></Tooltip>}
                  </Space>
                )},
                { title: 'Código', dataIndex: 'codigo', width: 120, render: (v) => <Tag color="blue">{v}</Tag> },
                { title: 'TAG', dataIndex: 'tag', width: 100 },
                { title: 'Tipo', dataIndex: 'tipo_laudo', width: 180, render: v => { const tipos = { inspecao: 'Inspeção NR-13', cal_valvula: 'Calib. Válvula Seg.', cal_manometro: 'Calib. Manômetro', cal_pressostato: 'Calib. Pressostato', cal_transdutor: 'Calib. Transdutor', cal_pneu: 'Calib. Calibrador Pneu', cal_termometro: 'Calib. Termômetro', prontuario: 'Prontuário', livro: 'Livro de Registro' }; return tipos[v] || v || '-'; } },
                { title: 'Data Inspeção', dataIndex: 'data_inspecao', width: 120, render: (v) => v ? new Date(v).toLocaleDateString('pt-BR') : '-' },
                { title: 'Validade', width: 130, render: (_, r) => {
                  // Inspeção NR-13: usa proxima_inspecao_externa
                  if (r.proxima_inspecao_externa) {
                    const d = r.proxima_inspecao_externa.substring(0,10);
                    const diff = Math.ceil((new Date(d) - new Date(new Date().toISOString().substring(0,10))) / (1000*60*60*24));
                    const cor = diff < 0 ? 'red' : diff <= 60 ? 'orange' : 'green';
                    return <Tag color={cor}>{new Date(d + 'T12:00:00').toLocaleDateString('pt-BR')}</Tag>;
                  }
                  if (r.data_inspecao && r.validade_anos) {
                    const venc = new Date(r.data_inspecao.substring(0,10) + 'T12:00:00');
                    venc.setFullYear(venc.getFullYear() + parseInt(r.validade_anos));
                    const diff = Math.ceil((venc - new Date(new Date().toISOString().substring(0,10))) / (1000*60*60*24));
                    const cor = diff < 0 ? 'red' : diff <= 60 ? 'orange' : 'green';
                    return <Tag color={cor}>{venc.toLocaleDateString('pt-BR')}</Tag>;
                  }
                  return '-';
                }},
                { title: 'Técnico', dataIndex: 'tecnico', width: 120 },
                { title: 'Status', dataIndex: 'status', width: 100, render: (v) => <Tag color={v==='finalizado'?'green':v==='rascunho'?'default':'orange'}>{v}</Tag> },
                { title: 'Docs', width: 90, render: (_, r) => (
                  <Space size={2}>
                    {r.possui_livro && <Tag color="purple" style={{fontSize:10}}>Livro</Tag>}
                    {r.possui_prontuario && <Tag color="cyan" style={{fontSize:10}}>Pront.</Tag>}
                  </Space>
                )},
                { title: 'Origem', dataIndex: 'origem', width: 100, render: (v) => <Tag>{v}</Tag> },
              ]}
            />
          </Card>
        </Tabs.TabPane>
      </Tabs>

      <Modal title={`Dados Financeiros — ${propostaSelecionada?.numero}`} open={modalFinanceiro} onCancel={() => setModalFinanceiro(false)} onOk={salvarFinanceiro} okText="Salvar" width={500}>
        {propostaSelecionada && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 16 }}>
            <div>
              <Text strong>Vencimento do Boleto:</Text>
              <DatePicker
                style={{ width: '100%', marginTop: 4 }}
                format="DD/MM/YYYY"
                value={formFinanceiro.vencimento_boleto}
                onChange={(date) => setFormFinanceiro({ ...formFinanceiro, vencimento_boleto: date })}
              />
            </div>
            <div>
              <Text strong>Status do Pagamento:</Text>
              <Select style={{ width: '100%', marginTop: 4 }} value={formFinanceiro.status_pagamento} onChange={(v) => setFormFinanceiro({ ...formFinanceiro, status_pagamento: v })}>
                <Option value="pendente">Pendente</Option>
                <Option value="em_dia">Em dia</Option>
                <Option value="pago">Pago</Option>
                <Option value="vencido">Vencido</Option>
              </Select>
            </div>
            <div>
              <Text strong>Status da NF:</Text>
              <Select style={{ width: '100%', marginTop: 4 }} value={formFinanceiro.status_nf} onChange={(v) => setFormFinanceiro({ ...formFinanceiro, status_nf: v })}>
                <Option value="nao_emitida">Não emitida</Option>
                <Option value="emitida">Emitida</Option>
                <Option value="enviada">Enviada ao cliente</Option>
              </Select>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Text strong>Inadimplente:</Text>
              <Switch checked={formFinanceiro.inadimplente} onChange={(v) => setFormFinanceiro({ ...formFinanceiro, inadimplente: v })} checkedChildren="SIM" unCheckedChildren="NÃO" />
            </div>
          </div>
        )}
      </Modal>
    </div>
    <ModalVersoes
      propostaId={propostaVersoes?.id}
      tipoProposta={propostaVersoes?.tipo_proposta || (String(propostaVersoes?.numero || '').startsWith('PP') ? 'produto' : 'servico')}
      open={modalVersoes}
      onClose={() => { setModalVersoes(false); setPropostaVersoes(null); }}
    />
    {/* Modal WhatsApp */}
    <Modal title={<span><WhatsAppOutlined style={{color:'#25d366'}}/> Enviar por WhatsApp</span>}
      open={modalWA} onCancel={() => setModalWA(false)} footer={null} width={500}>
      {propostaWA && (
        <div>
          <p style={{marginBottom:16}}>Selecione o número para enviar a proposta <strong>{propostaWA.numero}</strong>:</p>
          <Select style={{width:'100%', marginBottom:16}} placeholder="Selecione o contato" value={numeroWA || undefined} onChange={v => setNumeroWA(v)}>
            {contatosProp.filter(c => c.telefone).map(c => (
              <Option key={c.id} value={c.telefone.replace(/\D/g,'')}>{c.nome} — {c.telefone}</Option>
            ))}
          </Select>
          <Input.TextArea rows={4} style={{marginBottom:16}}
            value={msgWA}
            onChange={e => setMsgWA(e.target.value)} />
          <div style={{marginBottom:12}}>
            <p style={{fontSize:13, fontWeight:'bold', marginBottom:6}}>Anexos (opcional):</p>
            <Select mode="multiple" style={{width:'100%'}} placeholder="Selecione os anexos" value={anexosWA} onChange={v => setAnexosWA(v)}>
              <Option value="proposta_pdf">📄 Proposta PDF</Option>
              <Option value="boleto_pdf" disabled={!dadosWA?.boleto}>📋 Boleto PDF {!dadosWA?.boleto && '(não disponível)'}</Option>
              <Option value="nfse_pdf" disabled={!dadosWA?.nfse}>🧾 NFS-e PDF {!dadosWA?.nfse && '(não disponível)'}</Option>
            </Select>
          </div>
          <Button type="primary" block loading={enviandoWA}
            style={{background:'#25d366', borderColor:'#25d366'}}
            onClick={async () => {
              if (!numeroWA) { message.error('Selecione um contato'); return; }
              setEnviandoWA(true);
              try {
                const msg = msgWA;
                // Enviar mensagem de texto
                await api.post('/whatsapp/enviar-avulso', { numero: numeroWA, mensagem: msg });
                // Enviar anexos selecionados
                if (anexosWA.length > 0) {
                  const conn = await api.get('/whatsapp/conexoes');
                  const conexaoAtiva = conn.data.find(c => c.status === 'conectado');
                  if (conexaoAtiva) {
                    for (const anexo of anexosWA) {
                      try {
                        message.loading({ content: `Enviando ${anexo}...`, key: anexo });
                        let pdfResp, nomeArq;
                        if (anexo === 'proposta_pdf') {
                          pdfResp = await api.get(`/propostas/${propostaWA.id}/pdf`, { responseType: 'blob' });
                          nomeArq = `Proposta_${propostaWA.numero}.pdf`;
                        } else if (anexo === 'boleto_pdf' && dadosWA?.boleto) {
                          pdfResp = await api.get(`/boletos/${dadosWA.boleto.id}/pdf`, { responseType: 'blob' });
                          nomeArq = `Boleto.pdf`;
                        } else if (anexo === 'nfse_pdf' && dadosWA?.nfse) {
                          pdfResp = await api.get(`/nfse/${dadosWA.nfse.id}/pdf`, { responseType: 'blob' });
                          nomeArq = `NFSe_${dadosWA.nfse.numero}.pdf`;
                        }
                        if (pdfResp) {
                          const fd = new FormData();
                          fd.append('arquivo', new Blob([pdfResp.data], { type: 'application/pdf' }), nomeArq);
                          await api.post(`/whatsapp/conversas/avulso/arquivo?numero=${numeroWA}&conexao_id=${conexaoAtiva.id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                          message.success({ content: `${nomeArq} enviado!`, key: anexo });
                        }
                      } catch(e) { message.error({ content: `Erro ao enviar ${anexo}`, key: anexo }); }
                    }
                  }
                }
                message.success('Mensagem enviada pelo WhatsApp!');
                setModalWA(false);
              } catch(e) { message.error('Erro ao enviar: ' + (e.response?.data?.erro || e.message)); }
              finally { setEnviandoWA(false); }
            }}>Enviar</Button>
        </div>
      )}
    </Modal>

    <ModalComunicacao
      propostaId={propostaComunicacao}
      open={modalComunicacao}
      onClose={() => { setModalComunicacao(false); setPropostaComunicacao(null); }}
    />

    {/* Modal Tipo de Proposta */}
    <Modal title="Nova Proposta" open={modalTipoProposta} onCancel={() => setModalTipoProposta(false)} footer={null} width={400}>
      <div style={{ textAlign: 'center', padding: 20 }}>
        <p style={{ marginBottom: 24, color: '#666' }}>Selecione o tipo de proposta:</p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
          <div style={{ cursor: 'pointer', padding: 24, border: '2px solid #0099FF', borderRadius: 12, width: 150, textAlign: 'center' }}
            onClick={() => { setModalTipoProposta(false); abrirNovaPropostaModal(); }}>
            <div style={{ fontSize: 32 }}>🔧</div>
            <div style={{ marginTop: 8, fontWeight: 'bold', color: '#0099FF' }}>Serviço</div>
            <div style={{ fontSize: 11, color: '#888' }}>Inspeção, calibração, etc.</div>
          </div>
          <div style={{ cursor: 'pointer', padding: 24, border: '2px solid #52c41a', borderRadius: 12, width: 150, textAlign: 'center' }}
            onClick={() => { setModalTipoProposta(false); navigate('/propostas-produtos/novo?cliente_id=' + id); }}>
            <div style={{ fontSize: 32 }}>📦</div>
            <div style={{ marginTop: 8, fontWeight: 'bold', color: '#52c41a' }}>Produto</div>
            <div style={{ fontSize: 11, color: '#888' }}>Venda de materiais</div>
          </div>
        </div>
      </div>
    </Modal>

    {/* Modal Nova Proposta */}
    <Modal title="Nova Proposta" open={modalNovaProposta} onCancel={() => setModalNovaProposta(false)} footer={null} width={950} style={{ top: 20 }}>
      <Steps current={stepProposta} style={{ marginBottom: 24 }} items={[{ title: 'Deslocamento' }, { title: 'Serviços e Revisão' }]} />

      <div style={{ display: stepProposta === 0 ? 'block' : 'none' }}>
        <Form form={formProposta} layout="vertical" preserve={true}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="cnpj_faturamento_id" label="CNPJ para Faturamento">
                <Select onChange={(v) => setCnpjSelecionadoProp(cnpjsProp.find(c => c.id === v))} placeholder="Selecione o CNPJ" allowClear>
                  {cnpjsProp.map(c => <Option key={c.id} value={c.id}>{c.cnpj} — {c.razao_social} {c.matriz ? '(Matriz)' : ''}</Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="titulo" label="Título da Proposta" rules={[{ required: true }]}>
                <Input placeholder="Ex: Inspeção NR-13 2026" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="contato_id" label="Contato Responsável">
                <Select placeholder="Selecione o contato" allowClear>
                  {contatosProp.map(c => <Option key={c.id} value={c.id}>{c.nome} — {c.setor}</Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="endereco_id" label="Endereço de Atendimento">
                <Select placeholder="Selecione o endereço" allowClear>
                  {enderecosProp.map(e => <Option key={e.id} value={e.id}>{e.nome_local} — {e.cidade}/{e.estado}</Option>)}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation="left">Deslocamento</Divider>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="tipo_deslocamento" label="Tipo" initialValue="perto"><Select onChange={v => setTipoDeslocamentoProp(v)}><Option value="perto">Perto (sem pernoite)</Option><Option value="viagem">Viagem (com pernoite)</Option><Option value="celum">Entrega e retirada na Celum</Option></Select></Form.Item></Col>
            <Col span={8}><Form.Item name="dias_execucao" label="Dias de execução" initialValue={1}><InputNumber style={{ width: '100%' }} min={1} /></Form.Item></Col>
            <Col span={8}><Form.Item name="horas_deslocamento" label="Horas deslocamento"><InputNumber style={{ width: '100%' }} min={0} step={0.5} /></Form.Item></Col>
          </Row>
          {tipoDeslocamentoProp === 'celum' ? (<div style={{ background: '#eafaf1', border: '1px solid #7fd6a5', borderRadius: 8, padding: '10px 14px', marginBottom: 12 }}>🏢 <b>Entrega e retirada na Celum</b> — sem custo de mobilização (km, horas, pedágio, alimentação). Os itens ficam só com o valor base.</div>) : tipoDeslocamentoProp === 'perto' ? (
            <Row gutter={16}>
              <Col span={8}><Form.Item name="distancia_km" label="Distância km"><InputNumber style={{ width: '100%' }} min={0} /></Form.Item></Col>
              <Col span={8}><Form.Item name="pedagio_valor" label="Pedágio R$"><InputNumber style={{ width: '100%' }} min={0} precision={2} /></Form.Item></Col>
              <Col span={24}><Space wrap><Button type="dashed" onClick={calcularDeslocamentoProp} loading={calcRotaProp}>📍 Calcular km, tempo e pedágio pelo Google Maps</Button>{rotaInfoProp && <span style={{ color: '#888', fontSize: 12 }}>{rotaInfoProp}</span>}</Space></Col>
              <Col span={8}><Form.Item name="horas_estacionamento" label="Horas estacionamento"><InputNumber style={{ width: '100%' }} min={0} step={0.5} /></Form.Item></Col>
            </Row>
          ) : (
            <Row gutter={16}>
              <Col span={6}><Form.Item name="km_viagem" label="Km viagem"><InputNumber style={{ width: '100%' }} min={0} /></Form.Item></Col>
              <Col span={6}><Form.Item name="dias_totais_viagem" label="Dias totais"><InputNumber style={{ width: '100%' }} min={1} /></Form.Item></Col>
              <Col span={6}><Form.Item name="pedagio_valor" label="Pedágio R$"><InputNumber style={{ width: '100%' }} min={0} precision={2} /></Form.Item></Col>
              <Col span={24}><Space wrap><Button type="dashed" onClick={calcularDeslocamentoProp} loading={calcRotaProp}>📍 Calcular km, tempo e pedágio pelo Google Maps</Button>{rotaInfoProp && <span style={{ color: '#888', fontSize: 12 }}>{rotaInfoProp}</span>}</Space></Col>
              <Col span={6}><Form.Item name="diarias_aluguel_carro" label="Diárias aluguel"><InputNumber style={{ width: '100%' }} min={0} /></Form.Item></Col>
            </Row>
          )}
          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={6}><div style={{ padding: 12, background: '#fff7e6', borderRadius: 8, border: '1px solid #ffd591' }}><Checkbox checked={creaForaMGProp} onChange={e => setCreaForaMGProp(e.target.checked)}><Text strong>CREA fora de MG</Text></Checkbox></div></Col>
            <Col span={6}><div style={{ padding: 12, background: '#f6ffed', borderRadius: 8, border: '1px solid #b7eb8f' }}><Checkbox checked={incluirARTProp} onChange={e => setIncluirARTProp(e.target.checked)}><Text strong>Incluir ART?</Text></Checkbox></div></Col>
            <Col span={6}><Form.Item name="forma_pagamento" label="Forma de Pagamento"><Select>{FORMAS_PAGAMENTO.map(f => <Option key={f} value={f}>{f}</Option>)}</Select></Form.Item></Col>
            <Col span={6}><Form.Item name="validade_dias" label="Validade (dias)" initialValue={15}><InputNumber style={{ width: '100%' }} min={1} /></Form.Item></Col>
          </Row>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="primary" onClick={() => { dadosRefProp.current = formProposta.getFieldsValue(true); setStepProposta(1); }}>Próximo: Serviços →</Button>
          </div>
        </Form>
      </div>

      {stepProposta === 1 && (
        <div>
          <Form form={formItensProp} layout="vertical" onFinish={adicionarItemProposta}>
            <Row gutter={16} align="bottom">
              <Col span={14}>
                <Form.Item name="servico_id" label="Serviço" rules={[{ required: true }]}>
                  <Select showSearch optionFilterProp="children" placeholder="Selecione o serviço">
                    {servicos.map(s => <Option key={s.id} value={s.id}>{s.nome}{s.equipamento ? ` — ${s.equipamento}` : ''}</Option>)}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}><Form.Item name="quantidade" label="Qtd." initialValue={1}><InputNumber style={{ width: '100%' }} min={1} /></Form.Item></Col>
              <Col span={6}><Form.Item label=" "><Button type="primary" htmlType="submit" icon={<PlusOutlined />} block>Adicionar</Button></Form.Item></Col>
            </Row>
          </Form>
          <Divider>Serviços adicionados ({itensProposta.length})</Divider>
          {itensProposta.map((item, idx) => (
            <Card key={idx} size="small" style={{ marginBottom: 8 }} extra={<Button size="small" danger onClick={() => setItensProposta(itensProposta.filter((_, i) => i !== idx))}>Remover</Button>}>
              <Text strong>{item.nome}</Text>{item.equipamento && <Text type="secondary"> — {item.equipamento}</Text>} | Qtd: {item.quantidade}
            </Card>
          ))}
          <Row gutter={16} style={{ marginTop: 12 }}>
            <Col span={8}><InputNumber style={{ width: '100%' }} min={0} precision={2} placeholder="Desconto R$" onChange={v => dadosRefProp.current.desconto = v} /></Col>
            <Col span={16}><Input placeholder="Motivo do desconto" onChange={e => dadosRefProp.current.desconto_observacao = e.target.value} /></Col>
          </Row>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
            <Button onClick={() => setStepProposta(0)}>← Voltar</Button>
            <Button type="primary" icon={<CalculatorOutlined />} onClick={calcularProposta} disabled={itensProposta.length === 0}>Calcular</Button>
            {calculoProposta && <Button type="primary" style={{ background: '#52c41a', borderColor: '#52c41a' }} onClick={salvarNovaProposta} size="large">Salvar Proposta</Button>}
          </div>
          {calculoProposta && (
            <Card size="small" style={{ marginTop: 16, background: '#f6ffed', border: '1px solid #b7eb8f' }}>
              <Row gutter={16}>
                {calculoProposta.itens_calculados.map((item, i) => (
                  <Col span={24} key={i} style={{ marginBottom: 4 }}>
                    <Text>{item.nome}{item.equipamento ? ' — ' + item.equipamento : ''} | Qtd: {item.quantidade} | Unit: <Text strong>{fmt(item.valor_unitario)}</Text> | Total: <Text strong style={{ color: '#1a3c5e' }}>{fmt(item.valor_total)}</Text></Text>
                  </Col>
                ))}
              </Row>
              <Row style={{ marginTop: 8, borderTop: '1px solid #b7eb8f', paddingTop: 8 }}>
                <Col span={12}><Text>Subtotal: <Text strong>{fmt(calculoProposta.subtotal)}</Text></Text></Col>
                <Col span={12} style={{ textAlign: 'right' }}>
                  {calculoProposta.desconto > 0 && <Text style={{ color: 'red' }}>Desconto: - <Text strong>{fmt(calculoProposta.desconto)}</Text><br /></Text>}
                  <Text>Imposto: <Text strong>{fmt(calculoProposta.valor_imposto)}</Text></Text><br />
                  <Title level={4} style={{ margin: 0 }}>TOTAL: {fmt(calculoProposta.valor_total)}</Title>
                </Col>
              </Row>
            </Card>
          )}
        </div>
      )}


    </Modal>

      {/* Modal Laudos Externos */}
      <Modal
        title="Importar Laudos Externos"
        open={modalLaudosExternos}
        onCancel={() => { setModalLaudosExternos(false); setArquivosUpload([]); }}
        footer={null}
        width={800}
      >
        {arquivosUpload.length === 0 ? (
          <div style={{ textAlign: "center", padding: 40, border: "2px dashed #d9d9d9", borderRadius: 8 }}>
            <InboxOutlined style={{ fontSize: 48, color: "#0099FF" }} />
            <p style={{ marginTop: 16, fontSize: 16 }}>Selecione os arquivos PDF, DOC ou DOCX</p>
            <input type="file" multiple accept=".pdf,.doc,.docx" style={{ marginTop: 12 }}
              onChange={e => {
                const files = Array.from(e.target.files);
                setArquivosUpload(files.map(f => ({ file: f, nome: f.name, tag: "", tipo: "inspecao", data_proxima_atividade: null })));
              }}
            />
          </div>
        ) : (
          <div>
            <p style={{ marginBottom: 12 }}><strong>{arquivosUpload.length} arquivo(s)</strong> selecionado(s). Preencha as informações de cada um:</p>
            {arquivosUpload.map((arq, idx) => (
              <Card key={idx} size="small" style={{ marginBottom: 8 }} title={arq.nome}>
                <Row gutter={12}>
                  <Col span={8}>
                    <Input placeholder="TAG do equipamento" value={arq.tag} onChange={e => {
                      const val = e.target.value;
                      setArquivosUpload(prev => prev.map((a, i) => i === idx ? {...a, tag: val} : a));
                    }} />
                  </Col>
                  <Col span={8}>
                    <Select placeholder="Tipo" style={{ width: '100%' }} value={arq.tipo} onChange={v => {
                      setArquivosUpload(prev => prev.map((a, i) => i === idx ? {...a, tipo: v} : a));
                    }}>
                      <Select.Option value="inspecao">Laudo de Inspeção</Select.Option>
                      <Select.Option value="cal_valvula">Calibração de Válvula de Segurança</Select.Option>
                      <Select.Option value="cal_manometro">Calibração de Manômetro</Select.Option>
                      <Select.Option value="cal_pressostato">Calibração de Pressostato</Select.Option>
                      <Select.Option value="cal_transdutor">Calibração de Transdutor de Pressão</Select.Option>
                      <Select.Option value="cal_pneu">Calibração de Calibrador de Pneu</Select.Option>
                      <Select.Option value="cal_termometro">Calibração de Termômetro</Select.Option>
                      <Select.Option value="prontuario">Prontuário</Select.Option>
                      <Select.Option value="livro">Livro de Registro</Select.Option>
                    </Select>
                  </Col>
                  <Col span={8}>
                    {(arq.tipo === 'inspecao' || arq.tipo.startsWith('cal_')) && (
                      <DatePicker placeholder="Data próxima atividade" style={{ width: '100%' }} format="DD/MM/YYYY" onChange={(date, ds) => {
                        const val = ds ? ds.split('/').reverse().join('-') : null;
                        setArquivosUpload(prev => prev.map((a, i) => i === idx ? {...a, data_proxima_atividade: val} : a));
                      }} />
                    )}
                  </Col>
                </Row>
              </Card>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
              <Button onClick={() => setArquivosUpload([])}>Voltar</Button>
              <Button type="primary" loading={salvandoExternos} onClick={async () => {
                setSalvandoExternos(true);
                try {
                  // Etapa 1: Upload dos arquivos
                  const formData = new FormData();
                  arquivosUpload.forEach(arq => formData.append('arquivos', arq.file));
                  const uploadR = await api.post('/laudos-externos/upload/' + id, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                  });
                  // Etapa 2: Salvar com metadados
                  const laudosParaSalvar = uploadR.data.arquivos.map((arq, idx) => ({
                    ...arq,
                    tag: arquivosUpload[idx]?.tag || '',
                    tipo: arquivosUpload[idx]?.tipo || 'inspecao',
                    data_proxima_atividade: arquivosUpload[idx]?.data_proxima_atividade || null,
                  }));
                  await api.post('/laudos-externos/salvar/' + id, { laudos: laudosParaSalvar });
                  message.success('Laudos importados com sucesso!');
                  setModalLaudosExternos(false);
                  setArquivosUpload([]);
                  carregarDados();
                } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
                finally { setSalvandoExternos(false); }
              }}>Salvar {arquivosUpload.length} laudo(s)</Button>
            </div>
          </div>
        )}
      </Modal>

    <Modal title={osDetalhe ? osDetalhe.numero : 'Gerar Ordem de Serviço'} open={modalOS} onCancel={() => { setModalOS(false); setOsDetalhe(null); setEditandoOS(false); }} footer={null} width={700}>
      {!osDetalhe ? (
        <>
          {propostaSelecionada && (
            <div style={{ background: '#f6f6f6', padding: 10, borderRadius: 6, marginBottom: 12, fontSize: 13 }}>
              <strong>Cliente:</strong> {propostaSelecionada.razao_social || propostaSelecionada.nome_cliente}<br/>
              <strong>CNPJ:</strong> {propostaSelecionada.cnpj || '-'}<br/>
              <strong>Proposta:</strong> {propostaSelecionada.numero}
            </div>
          )}
          <Form form={formOS} layout="vertical" onFinish={gerarOS}>
            <Row gutter={12}>
              <Col span={12}><Form.Item name="data_agendada" label="Data e Hora Agendada"><DatePicker showTime format="DD/MM/YYYY HH:mm" style={{ width: '100%' }} /></Form.Item></Col>
              <Col span={12}><Form.Item name="status" label="Status" initialValue="aberta"><Select><Option value="aberta">Aberta</Option><Option value="em_andamento">Em Andamento</Option><Option value="pausada">Pausada</Option><Option value="concluida">Concluída</Option><Option value="cancelada">Cancelada</Option></Select></Form.Item></Col>
            </Row>
            <Form.Item noStyle shouldUpdate>{() => (<Form.Item name="contato_id" label="Contato"><ContatoSelect clienteId={id} /></Form.Item>)}</Form.Item>
            <Form.Item name="tecnico" label="Técnico Responsável">
              <Select showSearch optionFilterProp="children" placeholder="Selecione o técnico">
                {usuarios.filter(u => u.ativo).map(u => <Option key={u.id} value={u.nome}>{u.nome} {u.crea ? '— CREA: ' + u.crea : ''}</Option>)}
              </Select>
            </Form.Item>
            <Form.Item name="endereco_atendimento" label="Endereço de Atendimento" rules={[{ required: true, message: 'Informe o endereço' }]}>
              <Input.TextArea rows={2} />
            </Form.Item>
            <Form.Item name="observacoes" label="Atividade / Serviços">
              <Input.TextArea rows={4} />
            </Form.Item>
            <Button type="primary" htmlType="submit" block icon={<CalendarOutlined />}>Criar OS</Button>
          </Form>
        </>
      ) : (
        <div>
          <Card size="small" style={{ marginBottom: 12 }} extra={
            <Space size={4}>
              <Button size="small" type="primary" icon={<FileTextOutlined />} onClick={() => { setTipoLaudo(null); setSubtipoLaudo(null); setSubsubtipoLaudo(null); setModalLaudo(true); }}>Criar Laudo</Button>
              <Button size="small" icon={<EditOutlined />} onClick={() => { setEditandoOS(true); formDetalhe.setFieldsValue({ ...osDetalhe, data_agendada: osDetalhe.data_agendada ? dayjs(osDetalhe.data_agendada) : null }); }}>Editar</Button>
            </Space>
          }>
            {editandoOS ? (
              <Form form={formDetalhe} layout="vertical" onFinish={async (values) => {
                await api.put('/os/' + osDetalhe.id, { ...osDetalhe, ...values, data_agendada: values.data_agendada?.toISOString() });
                const r = await api.get('/os/' + osDetalhe.id);
                setOsDetalhe(r.data);
                setEditandoOS(false);
                message.success('OS atualizada!');
              }}>
                <Row gutter={12}>
                  <Col span={12}><Form.Item name="data_agendada" label="Data e Hora"><DatePicker showTime format="DD/MM/YYYY HH:mm" style={{ width: '100%' }} /></Form.Item></Col>
                  <Col span={12}><Form.Item name="contato_id" label="Contato"><ContatoSelect clienteId={osDetalhe?.cliente_id} /></Form.Item></Col><Col span={12}><Form.Item name="tecnico" label="Técnico"><Select showSearch optionFilterProp="children">{usuarios.filter(u => u.ativo).map(u => <Option key={u.id} value={u.nome}>{u.nome} {u.crea ? '— CREA: ' + u.crea : ''}</Option>)}</Select></Form.Item></Col>
                </Row>
                <Form.Item name="endereco_atendimento" label="Endereço"><Input.TextArea rows={2} /></Form.Item>
                <Form.Item name="atividade" label="Atividade"><Input.TextArea rows={2} /></Form.Item>
                <Space><Button onClick={() => setEditandoOS(false)}>Cancelar</Button><Button type="primary" htmlType="submit">Salvar</Button></Space>
              </Form>
            ) : (
              <>
                <Space wrap>
                  <Text><strong>Cliente:</strong> {osDetalhe.razao_social || osDetalhe.nome_cliente}</Text>
                  <Text><strong>CNPJ:</strong> {osDetalhe.cnpj_filial || osDetalhe.cnpj || '-'}</Text>
                  <Text><strong>Técnico:</strong> {osDetalhe.tecnico || '-'}</Text>
                  <Text><strong>Data:</strong> {osDetalhe.data_agendada ? dayjs(osDetalhe.data_agendada).format('DD/MM/YYYY HH:mm') : '-'}</Text>
                  <Text><strong>Status:</strong> <Tag color={STATUS_COR[osDetalhe.status]}>{STATUS_LABEL[osDetalhe.status]}</Tag></Text>
                </Space>
                {osDetalhe.endereco_atendimento && <div style={{ marginTop: 8 }}><Text><strong>Endereço:</strong> {osDetalhe.endereco_atendimento}</Text></div>}
                {osDetalhe.atividade && <div style={{ marginTop: 8 }}><Text><strong>Atividade:</strong> {osDetalhe.atividade}</Text></div>}
              </>
            )}
          </Card>
          <Divider orientation="left">Atualizar Status</Divider>
          <Space wrap style={{ marginBottom: 12 }}>
            {Object.entries(STATUS_LABEL).map(([k, v]) => (
              <Button key={k} size="small" type={osDetalhe.status === k ? 'primary' : 'default'} onClick={() => atualizarStatusOS(k)}>{v}</Button>
            ))}
          </Space>
          <Divider orientation="left">Histórico</Divider>
          <List size="small" dataSource={osDetalhe.historico || []} style={{ marginBottom: 12 }}
            locale={{ emptyText: 'Nenhuma anotação ainda.' }}
            renderItem={h => (
              <List.Item>
                <div>
                  <Text type="secondary" style={{ fontSize: 11 }}>{dayjs(h.criado_em).format('DD/MM/YYYY HH:mm')} — {h.usuario}</Text>
                  <div>{h.texto}</div>
                </div>
              </List.Item>
            )} />
          <Input.TextArea rows={2} value={novaAnotacao} onChange={e => setNovaAnotacao(e.target.value)} placeholder="Nova anotação..." style={{ marginBottom: 8 }} />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
            <Space>
              <Button icon={<DownloadOutlined />} onClick={() => exportarICS(osDetalhe)}>Exportar Calendário</Button>
              <Upload accept=".pdf,.jpg,.jpeg,.png" showUploadList={false} beforeUpload={async (file) => {
                const fd = new FormData();
                fd.append('arquivo', file);
                try {
                  await api.post('/os/' + osDetalhe.id + '/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                  message.success('Arquivo enviado!');
                  const r = await api.get('/os/' + osDetalhe.id);
                  setOsDetalhe(r.data);
                } catch { message.error('Erro ao enviar'); }
                return false;
              }}><Button icon={<UploadOutlined />}>Upload OS/RDO</Button></Upload>
              {osDetalhe.arquivo_caminho && <Button icon={<FilePdfOutlined />} onClick={async () => {
                const r = await api.get('/os/' + osDetalhe.id + '/download', { responseType: 'blob' });
                const url = window.URL.createObjectURL(new Blob([r.data], { type: r.headers['content-type'] || 'application/pdf' }));
                window.open(url, '_blank');
              }}>Ver OS/RDO</Button>}
            </Space>
            <Button type="primary" onClick={salvarAnotacao}>Adicionar Anotação</Button>
          </div>
        </div>
      )}
    </Modal>

    </>
  );
}

export default ClienteDetalhe;